import { action, atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'

export * from './trading-navigation'
export * from './trading-positions'

export type PairView = 'chart' | 'details'
export const pairViewAtom = atom<PairView>('chart', 'pairViewAtom')

export const togglePairViewAction = action((ctx) => {
  pairViewAtom(ctx, (it) => (it === 'chart' ? 'details' : 'chart'))
}, 'togglePairViewAction')

export const mainChartHeightAtom = atom<number>(
  220,
  'mainChartHeightAtom',
).pipe(withLocalStorage({ key: `${STORAGE_PREFIX}/mainChartHeight` }))

export const compactChartHeightAtom = atom<number>(
  130,
  'compactChartHeightAtom',
).pipe(withLocalStorage({ key: `${STORAGE_PREFIX}/compactChartHeight` }))
